<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import LocalizedInput from '@/components/LocalizedInput.vue';
import StandardToggle from '../StandardToggle.vue';
import LocalizedEditor from '@/components/base/LocalizedEditor.vue';

import type { Locales, ProjectModuleEventConfigDto } from '@/services/types/api.types';

// CONST
const { t } = useI18n();

// PROPS
const props = defineProps<{
  languageEnabled: Locales[];
  editLocale: Locales;
  module: ProjectModuleEventConfigDto;
}>();
</script>
<template>
  <div class="module-event">
    <localized-input
      name="title"
      :label="t('global.label.title')"
      :editLocale="editLocale"
      outlined
      :language_enabled="props.languageEnabled"
    />
    <q-field :label="t('global.label.description')" stack-label borderless>
      <template v-slot:control>
        <localized-editor
          name="config.content"
          :label="t('global.label.content')"
          class="q-mt-sm full-width"
          :editLocale="props.editLocale"
          :language_enabled="languageEnabled"
        />
      </template>
    </q-field>
    <standard-toggle name="config.highlight" :label="t('project-module.admin.highlight')" outlined />
    <standard-toggle
      name="config.includeInTableOfContents"
      :label="t('project-module.admin.includeInTableOfContents')"
      outlined
    />
  </div>
</template>
